import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { WelcomeScreenComponent } from './welcome-screen.component';

@NgModule({
	declarations: [WelcomeScreenComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		DzButtonModule,
		SharedModule,
		GenericDirectivesModule
	],
	exports: [WelcomeScreenComponent]
})
export class WelcomeScreenModule { }
